import {IModalService} from "angular-ui-bootstrap";
import {IPromise} from "angular";

export class StrategyBuilderService {

    public static id = "strategyBuilderService";

    /** @ngInject */
    public constructor(private $uibModal: IModalService) {

    }

    public openStockScreener(): IPromise<string> {
        const options = {
            templateUrl: "app/apps/stockScreener/stockScreener.tpl.html",
            controller: "stockScreenerCtrl as stockScreenerCtrl",
            size: "fs",
            windowClass: "fsModalScreener",
            resolve: {
                actionText: () => "View in Strategy Builder"
            }
        };
        const instance = this.$uibModal.open(options);

        return instance.result;
    }
}
